import React, { useState, useEffect, useContext } from "react";
import axios from 'axios'

import { GlobalContext, HOST } from "./context/GlobalContext"

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Table from 'react-bootstrap/Table'
import Form from 'react-bootstrap/Form'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import Offcanvas from 'react-bootstrap/Offcanvas'

import './App.css';
import { ArrowBarUp, CardList, Check, PencilFill, Wallet2, X } from "react-bootstrap-icons";

const ORDEN_PAGO_API = HOST + '/api/inv/ordenPagos/'
const ORDEN_PAGO_UPDATE_API = HOST + '/api/inv/ordenPagos/update'

const CURRENCY_FORMAT = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
const DATE_FORMAT_SHORT = new Intl.DateTimeFormat('es', { year: 'numeric', month: 'long', day: '2-digit', day: '2-digit', timeZone: (Intl.DateTimeFormat().resolvedOptions().timeZone) })

function Pagos({ orden }) {
  const { setGlobalLoading, formDataToJson, setMailBody, setMailTitle, setShowMesage, dateForm, rol } = useContext(GlobalContext);

  const [ ordenPagoList, setOrdenPagoList ] = useState([])

  const [ show, setShow ] = useState(false)
  const [ action, setAction ] = useState('Crear Proveedor')

  const [ idPago, setIdPago ] = useState()
  const [ idOrden, setIdOrden ] = useState()
  const [ fechaPago, setFechaPago ] = useState()
  const [ tipoPago, setTipoPago ] = useState()
  const [ importe, setImporte ] = useState(0)
  const [ moneda, setMoneda ] = useState('MX')
  const [ comentario, setComentario ] = useState()
  const [ estatus, setEstatus ] = useState(true)

  useEffect(() => {
    if( orden.idOrden > 0 ){
      setGlobalLoading( true )
      getOrdenPago()
    }
  }, [orden]);

  const getOrdenPago = () => {
    axios({
      method: 'get',
      url: ORDEN_PAGO_API + orden.idOrden,
    })
    .then(result => {
      console.log("orden Pago", result.data)
      setOrdenPagoList( result.data )
      setGlobalLoading( false )
    })
    .catch(error => {
      console.log("error", error.message)
      setGlobalLoading( false )
    })
  }

  const showForm = (item) => {

    if( item ){
      let date  = new Date(item.fechaPago)
      let dateP =  date.getFullYear() + "-" + ((date.getMonth() + 1) < 10 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1)) + "-" + (date.getDate() < 10 ? "0" + date.getDate() : date.getDate())

      setAction('Actualizar Pago')
      setIdPago(item.idPago)
      setIdOrden(item.idOrden)
      setFechaPago(dateP)
      setTipoPago(item.tipoPago)
      setImporte(item.importe)
      setMoneda(item.moneda)
      setComentario(item.comentario)
      setEstatus(item.estatus)
    } else {
      setAction('Nuevo Pago')
      setIdPago(null)
      setIdOrden(orden.idOrden)
      setFechaPago(null)
      setTipoPago(null)
      setImporte(0)
      setMoneda('MX')
      setComentario(null)
      setEstatus(true)
    }

    setShow(true)
  }

  const updateItem = (e) => {
    e.preventDefault();
    setGlobalLoading( true )
    var form = document.getElementById('editorialForm');
		var formData = new FormData(form);
    formData.append('fechaPago', dateForm(fechaPago));

    var json = formDataToJson(formData)

    console.log('json to update orden de pago', json)

    axios.post(ORDEN_PAGO_UPDATE_API, json, {
			headers: { 'content-type': 'application/json' }
    }).then(result => {
      console.log("result update", result.data)
      getOrdenPago()
      setShow(false)
      setGlobalLoading( false )
    })
    .catch(error => {
      console.log("error", error.message)
      setShowMesage(true)
      setMailTitle('Error')
      setMailBody('Ocurrió un error al guardar tu registro. Por favor intentalo mas tarde.')
      setGlobalLoading( false )
    })
  }

  return (
    <>
      <Offcanvas show={show} onHide={ () => setShow(false) } placement={'end'}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <div className="title-form">{ action }</div>
            <div className="desc-form"> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form id="editorialForm" onSubmit={ updateItem }>
            <Container>
              <Row>
                <div>
                  <input type="hidden" name="idPago" value={ idPago } />
                  <input type="hidden" name="idOrden" value={ idOrden } />
                  <input type="hidden" name="estatus" value={ estatus } />
                  <Container>
                    <Row>
                      <Col md="6">
                        <Form.Group className='mb-3'>
                          <FloatingLabel label="Fecha">
                            <Form.Control required type="date" name="fechaPago" max={new Date().toISOString().split("T")[0]} value={ fechaPago } placeholder="" onChange={ (e) => setFechaPago( e.target.value ) }/>
                          </FloatingLabel>
                        </Form.Group>
                      </Col>

                      <Col md="6">
                        <Form.Group className='mb-3'>
                          <FloatingLabel label="Tipo Pago">
                            <Form.Select required name="tipoPago" value={ tipoPago } onChange={ (e) => setTipoPago( e.target.value ) }>
                              <option>Selecciona una opción</option>
                              <option value={ 'efectivo' }>Efectivo</option>
                              <option value={ 'cheque' }>Cheque</option>
                              <option value={ 'transferencia' }>transferencia</option>
                            </Form.Select>
                          </FloatingLabel>
                        </Form.Group>
                      </Col>

                      <Col md="6">
                        <Form.Group className='mb-3'>
                          <input type="hidden" name="moneda" value={ moneda } />
                          <FloatingLabel label="Moneda">
                            <Form.Control required disabled value={ moneda } onChange={ (e) => setMoneda( e.target.value ) } placeholder="" />
                          </FloatingLabel>
                        </Form.Group>
                      </Col>

                      <Col md="6">
                        <Form.Group className='mb-3'>
                          <FloatingLabel label="Importe">
                            <Form.Control required type='number' name="importe" value={ importe } onChange={ (e) => setImporte( e.target.value ) } placeholder="" />
                          </FloatingLabel>
                        </Form.Group>
                      </Col>

                      <Col md="6">
                        <Form.Group className='mb-3'>
                          <FloatingLabel label="Comentario">
                            <Form.Control required name="comentario" value={ comentario } onChange={ (e) => setComentario( e.target.value ) } placeholder="" />
                          </FloatingLabel>
                        </Form.Group>
                      </Col>

                    </Row>
                  </Container>
                  
                  <br/>
                  <div align="center">
                    <button type="button" className="cancel-btn" onClick={ () => setShow(false) } >{ 'Cancelar' }</button>&nbsp;&nbsp;
                    <button type="submit" className="grl-btn">{ 'Guardar' }</button>
                  </div>
                </div>
              </Row>
            </Container>
          </Form>
        </Offcanvas.Body>
      </Offcanvas>

      <Container>
        <Row>
          <Col md={ 9 }>
            <div className="section-subtitle"> Ordenes de pago </div>
            <br/>
          </Col>
          <Col md={ 3 } align="right">
            { parseInt(rol) === 2 && orden.idOrden > 0 && <div className="single-btn" onClick={ () => showForm() } > Nuevo </div> }
          </Col>
        </Row>
        <Row>
          <Col>
            <Table responsive>
              <thead>
                <tr>
                  <th># Pago</th>
                  <th>Fecha de pago</th>
                  <th>Importe</th>
                  <th>Moneda</th>
                  <th>Tipo de pago</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                { ordenPagoList.length == 0 && 
                  <tr>
                    <td colSpan="6"> <div>Sin registros</div> </td>
                  </tr>
                }
                { ordenPagoList.map( item => (
                  <tr key={ item.idPago }>
                    <td> 
                      <div className="item-link" onClick={ () => showForm(item) }> 
                        { item.idPago } 
                      </div>
                    </td>
                    <td> 
                      { DATE_FORMAT_SHORT.format((new Date( item.fechaPago )).getTime()) } 
                    </td>
                    <td> 
                      { CURRENCY_FORMAT.format( item.importe ) } 
                    </td>
                    <td> 
                      { item.moneda } 
                    </td>
                    <td> 
                      { item.tipoPago } 
                    </td>
                    <td align="right"> 
                    { parseInt(rol) === 2 &&  <PencilFill onClick={ () => showForm(item) } className="table-icon" /> }
                    </td>
                  </tr>
                )) }
              </tbody>
            </Table>
          </Col>
        </Row>
      </Container>

    </>
  );
}

export default Pagos;
